import { cn } from "@/lib/utils";

// Ambient animated aurora / glow field used behind sections. Purely decorative.
export const AuroraBackground = ({ className = "", variant = "hero" }) => {
  return (
    <div aria-hidden="true" className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}>
      {variant === "hero" && (
        <>
          <div className="aurora-blob animate-aurora left-[-10%] top-[-15%] h-[45vw] w-[45vw] bg-nova-cyan/20" />
          <div className="aurora-blob animate-aurora left-[45%] top-[5%] h-[40vw] w-[40vw] bg-nova-emerald/15" style={{ animationDelay: "3s" }} />
          <div className="aurora-blob animate-aurora left-[20%] top-[40%] h-[35vw] w-[35vw] bg-nova-blue/10" style={{ animationDelay: "6s" }} />
        </>
      )}
      {variant === "soft" && (
        <>
          <div className="aurora-blob animate-aurora left-[-5%] top-[10%] h-[30vw] w-[30vw] bg-nova-cyan/10" />
          <div className="aurora-blob animate-aurora right-[-5%] bottom-[0%] h-[28vw] w-[28vw] bg-nova-emerald/10" style={{ animationDelay: "4s" }} />
        </>
      )}
      {/* faint grid */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
          WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
        }}
      />
    </div>
  );
};

export default AuroraBackground;
